import Brand from './Brand';
import './SiteFooter.css';

function SiteFooter() {
  return (
    <footer className="site-footer">
      <Brand />
      <nav aria-label="Footer navigation">
        <a href="/#how-it-works">How it works</a>
        <a href="/#features">Features</a>
        <a href="/#download">Download</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
      </nav>
      <p>
        &copy; 2026 Crumbs
        <br />
        All rights reserved.
      </p>
    </footer>
  );
}

export default SiteFooter;
